import PropTypes from 'prop-types';
import { useLayoutEffect, useRef } from 'react';
import decodeHtml from '../../../utils/decodeHtml';
import { ProductInfoStyle } from './ProductInfo.style';

const resolveScopedStyles = (scope) => {
  return {
    className: scope.props.className,
    styles: () => scope.props.children,
    wrapClassNames: (...classNames) => [scope.props.className, ...classNames].filter(Boolean).join(' '),
  };
};

const ProductInfo = ({ description }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const range = document.createRange();
    range.selectNode(ref.current);

    const wrapper = document.createElement('div');
    wrapper.innerHTML = decodeHtml(description);

    const images = wrapper.querySelectorAll('img');
    images.forEach((img) => {
      img.setAttribute('loading', 'lazy');

      // Fallback style if width/height missing
      if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
        img.setAttribute('style', 'max-width:100%;height:auto');
      }
    });

    const documentFragment = range.createContextualFragment(wrapper.innerHTML);

    ref.current.innerHTML = '';
    ref.current.appendChild(documentFragment);
  }, [description]);

  const style = resolveScopedStyles(
    <style>{`
        ${ProductInfoStyle}
      `}</style>
  );

  return (
    <>
      <div className={style.wrapClassNames('fb-product-information__product-information-tab')}>
        <div className={style.wrapClassNames('fb-product-information-tab__copy')} ref={ref} />
      </div>
      <style>{style.styles()}</style>
    </>
  );
};

ProductInfo.propTypes = {
  description: PropTypes.string.isRequired,
};

export default ProductInfo;
